import { render, staticRenderFns } from "./DocsModal.vue?vue&type=template&id=1b70d5e8"
import script from "./DocsModal.vue?vue&type=script&lang=js"
export * from "./DocsModal.vue?vue&type=script&lang=js"
import style0 from "./DocsModal.vue?vue&type=style&index=0&id=1b70d5e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports